function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCloseW = function SvgIconCloseW(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 15.22 15.22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.23 1.41 13.81 0l-6.2 6.2L1.41 0 0 1.41l6.2 6.2-6.2 6.2 1.41 1.41 6.2-6.19 6.2 6.19 1.42-1.41-6.2-6.2z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgIconCloseW;